module.exports = __webpack_public_path__ + "affd5ccee2b4433c94e31143b83aa9f6.svg";